'use strict';

angular.module('shiftTraderApp')
  .controller('ChangeMembershipPermissionModalCtrl', function ($scope, $uibModalInstance, SAErrorHandler, toastr,
                                                               Memberships, UserPermissionsService, params, orgPermissionSets) {
    $scope.close = function() {
      $uibModalInstance.dismiss(undefined);
    };

    $scope.org = params.org;
    $scope.user = params.user;

    $scope.membIdx = _.findIndex($scope.user.memberships, {organization_id: $scope.org.id});

    $scope.state = {
      selectionIsDifferent: false,
      initialSelection: $scope.user.memberships[$scope.membIdx].permission_set_id ? $scope.user.memberships[$scope.membIdx].permission_set_id : $scope.user.memberships[$scope.membIdx].role,
      currentSelection: $scope.user.memberships[$scope.membIdx].permission_set_id ? $scope.user.memberships[$scope.membIdx].permission_set_id : $scope.user.memberships[$scope.membIdx].role
    };

    // TODO: once we get rid of manager role, remove it from here
    $scope.state.showManagerOption = true;

    $scope.orgPermissionSets = orgPermissionSets;

    $scope.setsToDisplay = _.where($scope.orgPermissionSets, function(permSet) {
      // either the set is active OR this user is still assigned to it and it's inactive
      return permSet.active || $scope.user.memberships[$scope.membIdx].permission_set_id === permSet.id;
    });

    function evalIfCurrentIsDifferent() {
      $scope.state.selectionIsDifferent = ($scope.state.initialSelection !== $scope.state.currentSelection);
    }

    $scope.changeSelection = function(val) {
      $scope.state.currentSelection = val;
      evalIfCurrentIsDifferent();
    };

    function saveChange() {
      var data = {
        id: $scope.user.memberships[$scope.membIdx].id
      };

      // TODO: once we get rid of manager role, remove it from here
      if (_.contains(['admin', 'manager', 'employee'], $scope.state.currentSelection)) {
        data.role = $scope.state.currentSelection;
        data.permission_set_id = null;
      } else {
        data.role = null;
        data.permission_set_id = $scope.state.currentSelection;
      }

      Memberships.update(data)
        .then(function(updatedMembership) {
          console.log('updatedMembership', updatedMembership);

          $scope.user.memberships[$scope.membIdx].role = updatedMembership.role;
          $scope.user.memberships[$scope.membIdx].permission_set_id = updatedMembership.permission_set_id;
          toastr.success('Employee permissions updated!', 'Success');
          UserPermissionsService.forceDataRefresh();
          $uibModalInstance.close(updatedMembership);
        }, function() {
          toastr.error('Employee permissions did not update correctly. Try again later.', 'Error');
        });
    }

    $scope.footerButtonAction = function() {
      if ($scope.state.selectionIsDifferent) {
        saveChange();
      } else {
        $uibModalInstance.dismiss();
      }
    }




  });
